import React, { useEffect, useState } from "react";
import Swal from "sweetalert2";
import { useNavigate, Link } from "react-router-dom";
import { LOGIN_API } from "../../Services/Auth/Auth";
import { getCompanyApi } from "../../Services/Superadmin/Superadmin";
import { getGeneratePin, getMatchPin } from "../../Services/user/User"

const Login = () => {
  const navigate = useNavigate();
  const [username, setUsername] = useState("");

  const [password, setPassword] = useState("");
  const [errors, setErrors] = useState({});
  const [isPasswordVisible, setIsPasswordVisible] = useState(false);
  const [logo, setLogo] = useState("");
  const [panelName, setPanelName] = useState("");
  const [loading, setLoading] = useState(false);
  const [confirmPin, setConfirmPin] = useState("");

  // modal & pin states
  const [showPinModal, setShowPinModal] = useState(false);
  const [pin, setPin] = useState("");
  const [userId, setUserId] = useState("");

  useEffect(() => {
    fetchLogo();
  }, []);

  const handleUsernameChange = (e) => setUsername(e.target.value.toLowerCase());
  const handlePasswordChange = (e) => setPassword(e.target.value);
  const togglePasswordVisibility = () => setIsPasswordVisible((s) => !s);

  const validate = () => {
    const inputErrors = {};
    if (!username) inputErrors.username = "Username is required";
    if (!password) inputErrors.password = "Password is  ";
    return inputErrors;
  };

  const changeFavicon = (iconPath) => {
    const existing = document.querySelector("link[rel*='icon']");
    const link = existing || document.createElement("link");
    link.rel = "icon";
    link.href = iconPath;
    if (!existing) document.head.appendChild(link);
  };

  const fetchLogo = async () => {
    try {
      const res = await getCompanyApi();
      if (res?.data) {
        setLogo(res.data.logo || "");
        if (res.data.favicon) changeFavicon(res.data.favicon);
        if (res.data.panelName) {
          setPanelName(res.data.panelName);
          document.title = res.data.panelName;
        }
      }
    } catch (err) {
      // optional: console.error(err)
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const inputErrors = validate();
    if (Object.keys(inputErrors).length > 0) {
      setErrors(inputErrors);
      return;
    }

    setLoading(true);
    try {
      const response = await LOGIN_API({ UserName: username, password });
      const apiMsg = response?.data?.msg || response?.data?.message || response?.message || response?.msg;

      if (apiMsg && apiMsg.toString().toLowerCase().includes("generate") && apiMsg.toString().toLowerCase().includes("pin")) {
        const id = response?.data?.user_id || response?.data?.id || response?.user_id || "";
        setUserId(id);
        setShowPinModal(true);
        setLoading(false);
        return;
      }

      if (response?.status === false || response?.data?.status === false) {
        Swal.fire({ icon: "error", title: "Login failed", text: response?.data?.message || response?.message || "Unable to login" });
        setLoading(false);
        return;
      }

      const Role = response?.data?.Role;
      localStorage.setItem("market", JSON.stringify(response.data?.market || [0]));
      localStorage.setItem("research_permission", JSON.stringify(response?.data?.research_permission || [0]));
      // const displayName = data?.UserName || data?.username || username;
      localStorage.setItem("UserName", username);
      localStorage.setItem(
  "currentCurrency",
  response?.data?.market?.includes(0) ? "0" : "1"
);
      localStorage.setItem("user_id", response?.data?.user_id || response?.data?.id || "");
     localStorage.setItem("parent_id", response?.data?.parent_id || "");
      Swal.fire({ icon: "success", title: "Login successful", timer: 900, showConfirmButton: false }).then(() => {
        if (Role === "SUPERADMIN") navigate("/superadmin/dashboard");
        else if (Role === "ADMIN") navigate("/admin/dashboard");
        else if (Role === "EMPLOYE") navigate("/employee/dashboard");
        else if (Role === "USER") navigate("/user/dashboard");
      });
    } catch (error) {
      console.error("Login error:", error);
      Swal.fire({ icon: "error", title: "Login failed", text: error?.message || "Unexpected error" });
    } finally {
      setLoading(false);
    }
  };



  const handleGeneratePin = async (e) => {
    if (e && e.preventDefault) e.preventDefault();

    // client-side validation
    if (pin.length !== 4 || confirmPin.length !== 4) {
      Swal.fire({ icon: "warning", title: "Invalid PIN", text: "PIN must be 4 digits" });
      return;
    }
    if (pin !== confirmPin) {
      Swal.fire({ icon: "error", title: "PIN mismatch", text: "Both PIN fields must match" });
      return;
    }
    if (!userId) {
      Swal.fire({ icon: "error", title: "Missing User ID", text: "Cannot generate PIN without User ID" });
      return;
    }

    setLoading(true);
    try {
      const payload = { user_id: userId, pin: pin }; // backend expects mpin
      

      const genRes = await getGeneratePin(payload);
      if (genRes.error) {
        Swal.fire({ icon: "error", title: "PIN generation failed", text: genRes.message || "Something went wrong" });
        return;
      }
      const matchRes = await getMatchPin(payload);
      if (matchRes.error) {
        Swal.fire({ icon: "error", title: "PIN verification failed", text: matchRes.message || "PIN not matched" });
        return;
      }

      Swal.fire({ icon: "success", title: "PIN set successfully!", timer: 1200, showConfirmButton: false });
      setShowPinModal(false);
      setPin("");
      setConfirmPin("");
    } catch (err) {
      console.error("PIN flow error:", err);
      Swal.fire({ icon: "error", title: "Error", text: err?.message || "Unexpected error" });
    } finally {
      setLoading(false);
    }
  };



  // close modal on background click
  const backgroundClick = (e) => {
    if (e.target.classList.contains("modal-background")) {
      setShowPinModal(false);
    }
  };

  return (
    <>
      <div className="login-wrapper">
        <div className="login-card border-bars">
          <div className="left-side">
            <div className="logo-box">
              {logo ? (
                <img src={logo} alt="Brand" style={{ width: "70px", height: "70px", objectFit: "contain" }} />
              ) : (
                <span style={{ fontSize: "26px", fontWeight: "700" }}>CV</span>
              )}
            </div>

            <div className="left-title">{panelName || "Welcome"}</div>
            <div className="left-sub">Sign in to continue to your dashboard</div>
          </div>

          <div className="right-side">
            <h2>Sign In</h2>
            <p>Access your account</p>

            <form onSubmit={handleSubmit} noValidate>
              <div className="field">
                <label>Username</label>
                <div className="input-box">
                  <i className="fa fa-user" />
                  <input type="text" value={username} onChange={handleUsernameChange} />
                </div>
                {errors.username && <div className="error">{errors.username}</div>}
              </div>

              <div className="field">
                <label>Password</label>
                <div className="input-box">
                  <i className="fa fa-lock" />
                  <input type={isPasswordVisible ? "text" : "password"} value={password} onChange={handlePasswordChange} />
                  <i className={isPasswordVisible ? "fa fa-eye" : "fa fa-eye-slash"} style={{ cursor: "pointer" }} onClick={() => setIsPasswordVisible(!isPasswordVisible)} />
                </div>
                {errors.password && <div className="error">{errors.password}</div>}
              </div>

              <div className="row-between">
                <label>
                  <input type="checkbox" /> Remember me
                </label>

                <Link to="/forgot-password">Forgot?</Link>
              </div>

              <button type="submit" className="btn-login" disabled={loading}>
                {loading ? "..." : "Sign In"}
              </button>
            </form>

            <p style={{ marginTop: "15px", fontSize: "14px", textAlign: "center" }}>
              Don't have an account? <Link to="/register">Sign Up</Link>
            </p>

            <p style={{ marginTop: "8px", textAlign: "center", color: "#6b7280", fontSize: "13px" }}>
              © {new Date().getFullYear()} All rights reserved.
            </p>
          </div>
        </div>
      </div>

      {showPinModal && (
        <div className="modal-background" onClick={backgroundClick}>
          <div className="modal-box" role="dialog" aria-modal="true">
            <button className="modal-close" onClick={() => setShowPinModal(false)}>×</button>

            <h2>Create Your PIN</h2>

            <form onSubmit={handleGeneratePin}>
              <input
                name="pin"
                type="password"
                maxLength={4}
                inputMode="numeric"
                placeholder="Enter 4-digit PIN"
                value={pin}
                onChange={(e) => setPin(e.target.value.replace(/\D/g, "").slice(0, 4))}
                className="pin-input"
                style={{ marginBottom: 10 }}
                autoFocus
                required
              />

              <input
                name="confirmPin"
                type="password"
                maxLength={4}
                inputMode="numeric"
                placeholder="Re-enter PIN"
                value={confirmPin}
                onChange={(e) => setConfirmPin(e.target.value.replace(/\D/g, "").slice(0, 4))}
                className="pin-input"
                required
              />

              <div style={{ marginTop: 12, display: "flex", gap: 8 }}>
                {/* type="submit" so Enter key and click both submit */}
                <button type="submit" className="btn" disabled={loading || pin.length !== 4 || confirmPin.length !== 4}>
                  {loading ? "..." : "Set PIN"}
                </button>

                <button type="button" onClick={() => setShowPinModal(false)} className="btn btn-ghost">Cancel</button>
              </div>
            </form>
          </div>
        </div>
      )}


      {/* Minimal styles (move to your css/scss file) */}
      <style>{`
        .modal-background {
          position: fixed;
          inset: 0;
          display: flex;
          align-items: center;
          justify-content: center;
          background: rgba(0,0,0,0.5);
          z-index: 9999;
        }
        .modal-box {
          width: 360px;
          max-width: 90%;
          background: #fff;
          padding: 20px;
          border-radius: 8px;
          box-shadow: 0 6px 24px rgba(0,0,0,0.2);
          position: relative;
        }
        .modal-close {
          position: absolute;
          top: 8px;
          right: 10px;
          border: none;
          background: transparent;
          font-size: 20px;
          cursor: pointer;
        }
        .pin-input {
          width: 100%;
          padding: 10px;
          font-size: 18px;
          text-align: center;
          letter-spacing: 6px;
          box-sizing: border-box;
        }
        .btn { padding: 8px 12px; cursor: pointer; }
        .btn-ghost { background: transparent; border: 1px solid #ddd; }
      `}</style>
    </>
  );
};

export default Login;
